import { store } from "store/store";
import { updateToken } from "layouts/authentication/auth.reducer";

const successResponseHandler = (response) => {
  // The API re-issues the session token while an admin stays active (sliding
  // session). Ignored once signed out so a late response can't revive the session.
  const refreshedToken = response.headers["x-refreshed-token"];
  if (refreshedToken && store.getState().auth.isLoggedIn) {
    store.dispatch(updateToken(refreshedToken));
  }
  return response;
};

export default successResponseHandler;
